import { createAsyncThunk } from "@reduxjs/toolkit";
import { LOGIN_API_URL } from "@custom/constant";
import { LoginFormTypes } from "../../Auth/helper/auth";

 const loginApi = createAsyncThunk('login', async (loginData: LoginFormTypes, { rejectWithValue }) => {
  const payload = {
    ...loginData,
    tools_settings: {
      MeasurementTools: true,
      Zoom: true,
      WindowLevel: true,
      Pan: true,
      Capture: true,
      MoreTools: true,
      flipHorizontal: true,
      ReferenceLines: true,
      CobbAngle: true,
      Length: true,

      TrackballRotate: false,
      Layout: false,
      AnnotationPreferences: false,
      Crosshairs: false,

      Bidirectional: false,
      ArrowAnnotate: false,
      EllipticalROI: false,
      RectangleROI: false,
      CircleROI: false,
      PlanarFreehandROI: false,
      SplineROI: false,
      LivewireContour: false,

      Reset: false,
      'rotate-right': false,
      ImageSliceSync: false,
      ImageOverlayViewer: false,
      StackScroll: false,
      invert: false,
      Probe: false,
      Cine: false,
      Angle: false,
      Magnify: false,
      CalibrationLine: false,
      TagBrowser: false,
      AdvancedMagnify: false,
      UltrasoundDirectionalTool: false,
      WindowLevelRegion: false,
      toggleOverlay: false,
      copyToClipboard: false,
    },
    overlay_settings: {
      StudyPatientName: true,
      PatientId: true,
      PatientBirthDate: true,
      PatientSex: true,
      StudyID: true,
      StudyDate: true,
      ZoomLevel: true,
      InstanceNumber: true,
      WindowLevelOverlay: true,
    }
  }

  try {
    const response = await fetch(LOGIN_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  const data = await response.json();
  if (!response.ok) {
    return rejectWithValue(data || 'Login failed');
  }
  return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export default loginApi;
